function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.88756 14.7879L17.9999 7L19.3281 8.38352L9.86017 17.4728L5.32812 12.9407L6.68425 11.5846L9.88756 14.7879Z",
  fill: "#00BB77"
});
const SvgSubmitButtonIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSubmitButtonIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/submitButton_icon.534ebf4a.svg";
export { ForwardRef as ReactComponent };